
export const isReenterEmailRequired = () => {
  if (window && window.OA_REQUIRE_REENTER_EMAIL) {
    return !!window.OA_REQUIRE_REENTER_EMAIL;
  }

  return false;
};
